export enum eEditSingleFieldInputType {
  Currency,
  String,
}
